module.exports = __webpack_public_path__ + "img/right3(1).2d279349.png";